<template>
	<div ref="chart" style="width: 600px; height: 600px"></div>
</template>

<script>
import * as echarts from "echarts";

export default {
	data() {
		return {
			myChart: null,
		};
	},
	mounted() {
		let chartDom = this.$refs.chart,
			option = {
				tooltip: {
					trigger: "item",
				},
				legend: {
					top: "5%",
					left: "center",
				},
				series: [
					{
						name: "Access From",
						type: "pie",
						radius: ["40%", "70%"],
						avoidLabelOverlap: false,
						label: {
							show: false,
							position: "center",
						},
						emphasis: {
							label: {
								show: true,
								fontSize: "40",
								fontWeight: "bold",
							},
						},
						labelLine: {
							show: false,
						},
						data: this.getChartData(),
					},
				],
			};

		this.myChart = echarts.init(chartDom);
		this.myChart.setOption(option);
		console.log(option, this.myChart);
	},
	methods: {
		getChartData() {
			return [
				{ value: 1048, name: "Search Engine" },
				{ value: 735, name: "Direct" },
				{ value: 580, name: "Email" },
				{ value: 484, name: "Union Ads" },
				{ value: 300, name: "Video Ads" },
			];
		},
	},
};
</script>
